import { gql } from '@apollo/client';

const Fragments = {
  approvalTypeItem: gql`
    fragment approvalTypeItem on ApprovalTypeItem {
      approvalTypeId
      siteId
      approvalTypeCode
      approvalTypeName
      fourEyesPrinciple
      withNominalApproval
      decisionBehaviorId
    }
  `,
  approvalTypeLevelItem: gql`
    fragment approvalTypeLevelItem on ApprovalTypeLevelItem {
      approvalTypeLevelId
      siteId
      orderId
      levelName
      defaultEmployeeName
      isSystem
      approvalTypeId
    }
  `,
  approvalTypeDecisionReasonItem: gql`
    fragment approvalTypeDecisionReasonItem on ApprovalTypeDecisionReasonItem {
      decisionReasonId
      approvalTypeId
      reason
    }
  `,
  approvalTypeEmployeeItem: gql`
    fragment approvalTypeEmployeeItem on ApprovalTypeEmployeeItem {
      approvalTypeEmployeeId
      siteId
      approvalTypeId
      employeeId
      employeeName
      isDefault
      approvalTypeLevelId
    }
  `,
  approvalTypeUserGroupItem: gql`
    fragment approvalTypeUserGroupItem on ApprovalTypeUserGroupItem {
      approvalTypeUserGroupId
      approvalTypeId
      isDefault
      siteId
      userGroupId
      userGroupName
      approvalTypeLevelId
    }
  `
};

export default Fragments;
